import { useEffect, useState } from 'react'
import {
	Box,
	Button,
	FormControl,
	IconButton,
	InputAdornment,
	InputLabel,
	OutlinedInput,
	TextField,
	Typography
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import useLogin from '../hooks/useLogin'
import { useAppSelector } from '../redux/hooks'
import { Visibility, VisibilityOff } from '@mui/icons-material'

export const Login = () => {
	const { loginHandler, validateToken } = useLogin()
	const [showPassword, setShowPassword] = useState(false)

	const navigate = useNavigate()
	const { isAuthenticated } = useAppSelector((state) => state.auth)

	useEffect(() => {
		if (isAuthenticated) {
			navigate('/home')
		}
	}, [isAuthenticated])

	useEffect(() => {
		;(async () => {
			await validateToken()
		})()
	}, [])

	const handleSubmit = async (e: any) => {
		e.preventDefault()
		const { email, password } = e.target.elements
		if (!email.value || !password.value) {
			alert('Por favor, ingresa tu email y contraseña.')
			return
		}
		await loginHandler(email.value, password.value)
	}

	return (
		<>
			<Box overflow="hidden" position="absolute" top="0" right="0" left="0" bottom="0">
				<Box
					style={{
						backgroundColor: 'rgba(25, 125, 60, 1)',
						zIndex: -1,
						position: 'absolute',
						height: '100vh',
						width: '60vw'
					}}
					display={{ xs: 'none', lg: 'block' }}
				/>

				<Box
					alignItems="center"
					justifyContent="center"
					display="flex"
					flexDirection="row"
					height={'90vh'}
				>
					<Box
						alignItems="center"
						justifyContent="center"
						flexDirection="column"
						width={1}
						marginX={10}
						height={0.85}
						border={2}
						borderColor="black"
						borderRadius={4}
						display={{ xs: 'none', lg: 'flex' }}
					>
						<Typography variant="h2" component="div" gutterBottom>
							Sistema de Control de Semillas
						</Typography>
					</Box>

					<Box
						alignItems="center"
						justifyContent="center"
						display="flex"
						flexDirection="column"
						width={1}
					>
						<Box display="flex" justifyContent="center" marginY="2" width="10em">
							<img src="assets\ICTALogo.png" alt="ICTA Logo" width="75%" height="75%" />
						</Box>

						<Typography variant="h4" component="div" gutterBottom>
							Iniciar Sesión
						</Typography>

						<Box
							component="form"
							justifyContent="center"
							alignItems="center"
							display="flex"
							flexDirection="column"
							width={0.8}
							maxWidth={400}
							mt={2}
							onSubmit={handleSubmit}
						>
							<TextField
								fullWidth
								name="email"
								label="Email"
								type="text"
								variant="outlined"
								sx={{ marginY: 2 }}
							/>

							<FormControl fullWidth sx={{ marginY: 2 }} variant="outlined">
								<InputLabel>Contraseña</InputLabel>
								<OutlinedInput
									type={showPassword ? 'text' : 'password'}
									name="password"
									label="Contraseña"
									endAdornment={
										<InputAdornment position="end">
											<IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</InputAdornment>
									}
								/>
							</FormControl>

							<Button variant="contained" type="submit" sx={{ marginY: 2 }}>
								{' '}
								OK{' '}
							</Button>

							<Typography
								variant="subtitle1"
								component="div"
								alignSelf="start"
								sx={{ textDecoration: 'underline', cursor: 'pointer' }}
								onClick={() => navigate('/forgot-password')}
							>
								¿Olvidaste tu contraseña?
							</Typography>
						</Box>
					</Box>
				</Box>
			</Box>
		</>
	)
}
